import { render } from "./DevelopersOverviewComponent.vue?vue&type=template&id=1790adf6&scoped=true"
import script from "./DevelopersOverviewComponent.vue?vue&type=script&lang=js"
export * from "./DevelopersOverviewComponent.vue?vue&type=script&lang=js"

import "./DevelopersOverviewComponent.vue?vue&type=style&index=0&id=1790adf6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1790adf6"]])

export default __exports__